const Event = () => {
    return (
        <h1>
            evento
        </h1>
    )
}

export default Event